/**
 * Modular Verra Closet Configurator
 * Version: 1.0.1
 * Build: 5
 * Last Commit: 83de5cf
 * Build Date: 2025-09-01
 *
 * This file was automatically generated.
 * Do not edit the version header manually.
 */

import { gsap } from "gsap";
import * as THREE from "three";
//comment

// Door open angle in radians (default: 75 degrees)
export let DOOR_OPEN_ANGLE = (75 * Math.PI) / 180;

// Setter function to update door open angle
export function setDoorOpenAngle(angleRadians) {
  DOOR_OPEN_ANGLE = angleRadians;
}

// Getter function to get door open angle
export function getDoorOpenAngle() {
  return DOOR_OPEN_ANGLE;
}

function animateDoor(targetRotation, object, direction) {
  let rotationDirection;
  switch (direction) {
    case "left":
      rotationDirection = -1;
      break;
    case "right":
      rotationDirection = 1;
      break;
    default:
      console.error("Invalid direction for door.");
      return;
  }

  const finalRotation = targetRotation * rotationDirection;

  gsap.to(object.rotation, {
    duration: 1,
    y: finalRotation,
  });
}
const listOfOneDoorCabinets = ["16.5W_", "18W_", "19.5W_", "21W_"];
const checkIfOneDoorCabinet = (cabinet) => {
  return listOfOneDoorCabinets.some((name) => cabinet.name.includes(name));
};
const getDoor = (cabinet, side) => {
  let doors = [];
  let frames = [];
  if (checkIfOneDoorCabinet(cabinet)) {
    Object.keys(cabinet.part.door).forEach((key) => {
      if (cabinet.part.door[key]) {
        cabinet.part.door[key].traverse((child) => {
          if (child.isMesh && child.userData.isDoor) {
            doors.push(child);
          } else if (child.isMesh && child.userData.isFrame) {
            // frames.push(child);
          }
        });
      }
    });
  } else {
    Object.keys(cabinet.part.door).forEach((key) => {
      if (cabinet.part.door[key] && key.toLowerCase().includes(side)) {
        cabinet.part.door[key].traverse((child) => {
          if (child.isMesh && child.userData.isDoor) {
            doors.push(child);
          } else if (child.isMesh && child.userData.isFrame) {
            // frames.push(child);
          }
        });
      }
    });
  }

  return { doors, frames };
};

const getDoorHardware = (cabinet, side) => {
  let doorHardware = [];

  Object.keys(cabinet.part.doorHardware).forEach((key) => {
    if (side === "_l") {
      if (
        key.toLowerCase().includes("_l") ||
        key.toLowerCase().includes("_s")
      ) {
        if (cabinet.part.doorHardware[key]) {
          doorHardware.push(cabinet.part.doorHardware[key]);
        }
      }
    } else if (side === "_r") {
      if (key.toLowerCase().includes(side)) {
        if (cabinet.part.doorHardware[key]) {
          doorHardware.push(cabinet.part.doorHardware[key]);
        }
      }
    }
  });
  return { doorHardware };
};

// const getKnob = (cabinet, side) => {
//   let knobs = [];
//   Object.keys(cabinet.part.knob).forEach((key) => {
//     if (side === "_l") {
//       if (
//         key.toLowerCase().includes("_l") ||
//         key.toLowerCase().includes("_s")
//       ) {
//         if (cabinet.part.knob[key]) {
//           knobs.push(cabinet.part.knob[key]);
//         }
//       }
//     } else if (side === "_r") {
//       if (key.toLowerCase().includes(side)) {
//         if (cabinet.part.knob[key]) {
//           knobs.push(cabinet.part.knob[key]);
//         }
//       }
//     }
//   });
//   return { knobs };
// };
export function openLeftDoor(cabinet) {
  // debugger;
  const { doors, frames } = getDoor(cabinet, "_l");
  const { doorHardware } = getDoorHardware(cabinet, "_l");
  // const { knobs } = getKnob(cabinet, "_l");
  const box = new THREE.Box3().setFromObject(cabinet);
  doors.forEach((door) => {
    if (door) {
      animateDoor(DOOR_OPEN_ANGLE, door, "left");
    }
  });
  frames.forEach((frame) => {
    if (frame) {
      animateDoor(DOOR_OPEN_ANGLE, frame, "left");
    }
  });

  doorHardware.forEach((hardware) => {
    if (hardware) {
      // const object = pull.children[0];
      // pull.remove(object);
      // pull.position.set(box.min.x, 0, box.max.z);
      // pull.attach(object);
      animateDoor(DOOR_OPEN_ANGLE, hardware, "left");
    }
  });
}
export function openRightDoor(cabinet) {
  if (checkIfOneDoorCabinet(cabinet)) {
    return;
  }
  const { doors, frames } = getDoor(cabinet, "_r");
  const { doorHardware } = getDoorHardware(cabinet, "_r");
  // const { knobs } = getKnob(cabinet, "_r");
  const box = new THREE.Box3().setFromObject(cabinet);
  doors.forEach((door) => {
    if (door) {
      animateDoor(DOOR_OPEN_ANGLE, door, "right");
    }
  });
  frames.forEach((frame) => {
    if (frame) {
      animateDoor(DOOR_OPEN_ANGLE, frame, "right");
    }
  });
  doorHardware.forEach((hardware) => {
    if (hardware) {
      // const object = pull.children[0];
      // pull.remove(object);
      // pull.position.set(box.max.x, 0, box.max.z);
      // pull.attach(object);
      animateDoor(DOOR_OPEN_ANGLE, hardware, "right");
    }
  });
}
export function closeLeftDoor(cabinet) {
  const { doors, frames } = getDoor(cabinet, "_l");
  const { doorHardware } = getDoorHardware(cabinet, "_l");
  // const { knobs } = getKnob(cabinet, "_l");
  doors.forEach((door) => {
    if (door) {
      animateDoor(0, door, "left");
    }
  });
  frames.forEach((frame) => {
    if (frame) {
      animateDoor(0, frame, "left");
    }
  });
  doorHardware.forEach((hardware) => {
    if (hardware) {
      animateDoor(0, hardware, "left");
      // const object = pull.children[0];
      // pull.remove(object);
      // pull.position.set(0, 0, 0);
      // pull.attach(object);
    }
  });
}
export function closeRightDoor(cabinet) {
  const { doors, frames } = getDoor(cabinet, "_r");
  const { doorHardware } = getDoorHardware(cabinet, "_r");
  // const { knobs } = getKnob(cabinet, "_r");
  doors.forEach((door) => {
    if (door) {
      animateDoor(0, door, "right");
    }
  });
  frames.forEach((frame) => {
    if (frame) {
      animateDoor(0, frame, "right");
    }
  });
  doorHardware.forEach((hardware) => {
    if (hardware) {
      // const object = pull.children[0];
      // pull.remove(object);
      // pull.position.set(0, 0, 0);
      // pull.attach(object);
      animateDoor(0, hardware, "right");
    }
  });
}

function animateDoorInstant(targetRotation, object, direction) {
  let rotationDirection;
  switch (direction) {
    case "left":
      rotationDirection = -1;
      break;
    case "right":
      rotationDirection = 1;
      break;
    default:
      console.error("Invalid direction for door.");
      return;
  }

  const finalRotation = targetRotation * rotationDirection;
  object.rotation.y = finalRotation;
  /*
    gsap.to(object.rotation, {
        duration: 0,
        y: finalRotation,
    });
    */
}
export function openLeftDoorInstant(cabinet) {
  const { doors, frames } = getDoor(cabinet, "_l");
  doors.forEach((door) => {
    if (door) {
      animateDoorInstant(DOOR_OPEN_ANGLE, door, "left");
    }
  });
  frames.forEach((frame) => {
    if (frame) {
      animateDoorInstant(DOOR_OPEN_ANGLE, frame, "left");
    }
  });
}
export function openRightDoorInstant(cabinet) {
  if (checkIfOneDoorCabinet(cabinet)) {
    return;
  }
  const { doors, frames } = getDoor(cabinet, "_r");
  doors.forEach((door) => {
    if (door) {
      animateDoorInstant(DOOR_OPEN_ANGLE, door, "right");
    }
  });
  frames.forEach((frame) => {
    if (frame) {
      animateDoorInstant(DOOR_OPEN_ANGLE, frame, "right");
    }
  });
}
export function closeLeftDoorInstant(cabinet) {
  const { doors, frames } = getDoor(cabinet, "_l");
  doors.forEach((door) => {
    if (door) {
      animateDoorInstant(0, door, "left");
    }
  });
  frames.forEach((frame) => {
    if (frame) {
      animateDoorInstant(0, frame, "left");
    }
  });
}
export function closeRightDoorInstant(cabinet) {
  const { doors, frames } = getDoor(cabinet, "_r");
  doors.forEach((door) => {
    if (door) {
      animateDoorInstant(0, door, "right");
    }
  });
  frames.forEach((frame) => {
    if (frame) {
      animateDoorInstant(0, frame, "right");
    }
  });
}

/******************/
function animateDrawer(amount, object, duration) {
  const initialPosition = { z: object.position.z };
  const targetPosition = { z: initialPosition.z - amount };

  gsap.to(object.position, {
    duration: duration,
    z: targetPosition.z,
  });
}
/****/
export function openBottomDrawer(cabinet) {
  if (cabinet.slots.bottomDrawer) {
    animateDrawer(-0.4, cabinet.slots.bottomDrawer, 2);
  }
}
export function closeBottomDrawer(cabinet) {
  if (cabinet.slots.bottomDrawer) {
    animateDrawer(0.4, cabinet.slots.bottomDrawer, 2);
  }
}
/****/
export function openMiddleDrawer(cabinet) {
  if (cabinet.slots.middleDrawer) {
    animateDrawer(-0.4, cabinet.slots.middleDrawer, 2);
  }
}
export function closeMiddleDrawer(cabinet) {
  if (cabinet.slots.middleDrawer) {
    animateDrawer(0.4, cabinet.slots.middleDrawer, 2);
  }
}
/****/
export function openTopDrawer(cabinet) {
  if (cabinet.slots.topDrawer) {
    animateDrawer(-0.4, cabinet.slots.topDrawer, 2);
  }
}
export function closeTopDrawer(cabinet) {
  if (cabinet.slots.topDrawer) {
    animateDrawer(0.4, cabinet.slots.topDrawer, 2);
  }
}

/**********************/
function animateChest(amount, object, childIndex) {
  const firstChild = object.children[0];

  const child = firstChild.children[childIndex];
  gsap.killTweensOf(child.position);
  if (!child) {
    console.error(`Child at index ${childIndex} not found.`);
    return;
  }

  animateDrawer(amount, child, 2);
}
export function openChestBottomDrawer(cabinet) {
  animateChest(-0.4, cabinet.slots.chestOfDrawers, 2);
}
export function closeChestBottomDrawer(cabinet) {
  animateChest(0.4, cabinet.slots.chestOfDrawers, 2);
}
export function openChestMiddleDrawer(cabinet) {
  animateChest(-0.4, cabinet.slots.chestOfDrawers, 1);
}
export function closeChestMiddleDrawer(cabinet) {
  animateChest(0.4, cabinet.slots.chestOfDrawers, 1);
}
export function openChestTopDrawer(cabinet) {
  animateChest(-0.4, cabinet.slots.chestOfDrawers, 3);
}
export function closeChestTopDrawer(cabinet) {
  animateChest(0.4, cabinet.slots.chestOfDrawers, 3);
}
